var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 19.5,
    stroke: "#E4E5E7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.5 14.631H21V13.881C21 13.631 20.75 13.381 20.5 13.381H19.5C19.2187 13.381 19 13.631 19 13.881V14.631H12.5C12.2187 14.631 12 14.881 12 15.131V15.631C12 15.9122 12.2187 16.131 12.5 16.131H19V16.881C19 17.1622 19.2187 17.381 19.5 17.381H20.5C20.75 17.381 21 17.1622 21 16.881V16.131H27.5C27.75 16.131 28 15.9122 28 15.631V15.131C28 14.881 27.75 14.631 27.5 14.631ZM27.5 24.631H17V23.881C17 23.631 16.75 23.381 16.5 23.381H15.5C15.2187 23.381 15 23.631 15 23.881V24.631H12.5C12.2187 24.631 12 24.881 12 25.131V25.631C12 25.9122 12.2187 26.131 12.5 26.131H15V26.881C15 27.1622 15.2187 27.381 15.5 27.381H16.5C16.75 27.381 17 27.1622 17 26.881V26.131H27.5C27.75 26.131 28 25.9122 28 25.631V25.131C28 24.881 27.75 24.631 27.5 24.631ZM27.5 19.631H25V18.881C25 18.631 24.75 18.381 24.5 18.381H23.5C23.2187 18.381 23 18.631 23 18.881V19.631H12.5C12.2187 19.631 12 19.881 12 20.131V20.631C12 20.9122 12.2187 21.131 12.5 21.131H23V21.881C23 22.1622 23.2187 22.381 23.5 22.381H24.5C24.75 22.381 25 22.1622 25 21.881V21.131H27.5C27.75 21.131 28 20.9122 28 20.631V20.131C28 19.881 27.75 19.631 27.5 19.631Z",
    fill: "#525357"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.706e693a847a3e97b6f4dec961d3fb5a.svg";
export { ForwardRef as ReactComponent };